// src/pages/MSME/components/MSMEMetaAnimatedUniverse.jsx
import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTractor,
  faUsers,
  faShoppingCart,
  faWarehouse,
  faTruck,
  faSeedling,
  faCow,
  faFish,
  faEgg,
} from "@fortawesome/free-solid-svg-icons";

const stakeholders = [
  { id: 1, icon: faTractor, label: "Farmers" },
  { id: 2, icon: faUsers, label: "Families" },
  { id: 3, icon: faShoppingCart, label: "Buyers" },
  { id: 4, icon: faWarehouse, label: "Warehouse" },
  { id: 5, icon: faTruck, label: "Logistics" },
  { id: 6, icon: faSeedling, label: "Nursery" },
  { id: 7, icon: faCow, label: "Dairy" },
  { id: 8, icon: faEgg, label: "Poultry" },
  { id: 9, icon: faFish, label: "Fisheries" },
];

const MSMEMetaverseAnimatedUniverse = () => {
  const radius = 200; // distance from center to icons

  return (
    <div className="relative w-full max-w-4xl h-[500px] mx-auto mt-12 flex items-center justify-center overflow-visible">
      {/* Rotating circle frame */}
      <motion.div
        className="absolute w-[420px] h-[420px] rounded-full border-4 border-green-600"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
      />

      {/* Stakeholders evenly distributed */}
      {stakeholders.map((s, i) => {
        const angle = (i / stakeholders.length) * 2 * Math.PI; // angle in radians
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;

        return (
            <motion.div
            key={s.id}
            className="absolute flex flex-col items-center"
            style={{
                top: "50%",
                left: "50%",
                x, // initial x offset
                y, // initial y offset
                translateX: "-50%",
                translateY: "-50%",
            }}
            animate={{
                y: [y - 10, y + 10, y - 10], // vertical floating relative to circle
            }}
            transition={{
                repeat: Infinity,
                duration: 4,
                delay: i * 0.2,
                ease: "easeInOut",
            }}
            >
            <motion.div
                whileHover={{ scale: 1.3, rotate: 12 }}
                className="bg-white shadow-lg rounded-full p-4"
            >
                <FontAwesomeIcon icon={s.icon} className="text-green-700 text-2xl" />
            </motion.div>
            <span className="mt-2 text-white text-sm font-medium text-center">
                {s.label}
            </span>
            </motion.div>
        );
        })}


      {/* Center core */}
      <motion.div
        className="absolute w-36 h-36 rounded-full bg-green-700 text-white flex items-center justify-center text-lg font-bold shadow-2xl"
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ repeat: Infinity, duration: 3 }}
      >
        🌱 MSMEVerse
      </motion.div>
    </div>
  );
};

export default MSMEMetaverseAnimatedUniverse;
